import React, { Component } from 'react';
import {
   Col, Card, CardBody, Table, Button,
} from 'reactstrap';
import Moment from 'moment';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import CalendarIcon from 'mdi-react/CalendarIcon';

import CommonService from '../../../services/CommonService';
import StoreReportModal from '../../Stocks/components/StoreReportModal';
import global from '../../../global';

class SalesReport extends Component {
   constructor() {
      super();
      this.currDate = new Date();
      this.state = {
         modal: false,
         list: [],
         errorMsg: '',
         goTo: false,
         goToPage: '/',
         formdata: {
            inventoryDate: this.currDate,
            inventoryDate_txt: Moment(this.currDate).format('YYYY-MM-DD HH:mm:ss'),
         },
      };
      this.toggleModal = this.toggleModal.bind(this);
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      this.toggleReport = this.toggleReport.bind(this);
      this.changeInventoryDate = this.changeInventoryDate.bind(this);
   }

   componentDidMount() {
      this.isLoading = true;
      this.loadSalesReport();
   }

   loadSalesReport = async (invtDate = '') => {
      try {
         const storageData = JSON.parse(localStorage.getItem('salesReportDate'));
         const inventoryDate = invtDate !== '' ? invtDate : storageData !== null && invtDate === '' ? storageData.date : Moment(new Date()).format('YYYY-MM-DD');
         localStorage.setItem('salesReportDate', JSON.stringify({ type: 'report', date: inventoryDate }));

         let location = '';
         if (this.userdata.type !== '1' && this.userdata.type !== '5') {
            location = `/locationid/${this.userdata.location_id}`;
         }
         const response = await CommonService.getRows(`salesreportlist/type/${this.userdata.type}${location}/salesdate/${inventoryDate}`);
         if (this.isLoading && response) {
            this.setState({ list: response });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   handleChange = (e, fieldName) => {
      if (fieldName === 'inventoryDate') {
         const date = new Date(e);
         this.setState(prevState => ({
           formdata: {
             ...prevState.formdata,
             inventoryDate: date,
           },
         }));
      } else {
         const { name, value } = e.target;
         this.setState(prevState => ({
            formdata: { ...prevState.formdata, [name]: value },
         }));
      }
   }

   goTo = (ev) => {
      this.setState({ goTo: true, goToPage: `/report/sales/${ev.currentTarget.dataset.href}` });
   }

   changeInventoryDate(e) {
     e.preventDefault();
     const { formdata } = this.state;
     const inventoryDate = Moment(formdata.inventoryDate).format('YYYY-MM-DD');
     this.isLoading = true;
     this.loadSalesReport(inventoryDate);
   }

   toggleReport() {
     this.toggleModal();
     this.handleSubmit = (e) => { this.submitReport(e); };
   }

   submitReport(e) {
     e.preventDefault();
     const form = document.getElementById('store_daily_report');
     const formdata = new FormData(form);
     formdata.append('location_id', this.userdata.location_id);
     formdata.append('user_id', this.userdata.user_id);

     CommonService.insertData('storedailyreport', formdata, false).then((result) => {
       if (result.msg === true) {
         this.loadSalesReport();
         this.setState({ errorMsg: '', modal: false });
       } else {
         this.setState({ errorMsg: result.msg });
       }
     }).catch((err) => {
       console.log('Error: ', err.message);
     });
   }

   toggleModal() {
     this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         list, modal, errorMsg, goTo, goToPage, formdata,
      } = this.state;

      if (goTo === true) {
         return <Redirect to={goToPage} />;
      }

      // for search date
      let inventoryDate = new Date();
      let storageDate = new Date();

      if (localStorage.getItem('salesReportDate') !== null) {
         const storageData = JSON.parse(localStorage.getItem('salesReportDate'));
         storageDate = new Date(storageData.date);

         let formdate = new Date();
         if (formdata.inventoryDate) {
            formdate = new Date(formdata.inventoryDate);
         }

         inventoryDate = formdata.inventoryDate !== undefined && formdata.inventoryDate !== this.currDate ? formdate : storageDate;
      }

      return (
         <Col md={12}>
            <StoreReportModal
               title="Add Transaction"
               modal={modal}
               toggle={this.toggleModal}
               handleSubmit={this.handleSubmit}
               errorMsg={errorMsg}
            />
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                  <h5 className="bold-text">Sales Report</h5>
                  {
                     this.userdata && (this.userdata.type !== '1' && this.userdata.type !== '5') && (
                        <div className="panel__btns">
                        <Button onClick={this.toggleReport} className="rounded text-white btn-awesome" size="sm" outline>
                           <i className="fa fa-clipboard-check" />
                           <span>Submit Daily Sales Report</span>
                        </Button>
                        </div>
                     )
                  }
                  </div>
                  <div className="panel__content">
                  <div className="float-right">
                     <form className="form form--horizontal" onSubmit={this.changeInventoryDate}>
                        <div className="form__form-group m-b-10">
                           <span className="form__form-group-label text-right">Date:</span>
                           <div className="form__form-group-field">
                              <div className="form__form-group-icon">
                                 <CalendarIcon />
                              </div>
                              <div className="date-picker">
                                 <DatePicker
                                    name="inventoryDate"
                                    selected={inventoryDate}
                                    popperPlacement="top-end"
                                    onChange={e => this.handleChange(e, 'inventoryDate')}
                                 />
                              </div>
                              <button type="submit" className="form__form-group-button bg-primary"><i className="fa fa-search" /></button>
                           </div>
                        </div>
                     </form>
                  </div>

                  <Table responsive striped hover>
                     <thead className="th-vtop">
                        <tr>
                           <th>Location</th>
                           <th>Sales Date</th>
                           <th>Total Sales</th>
                           <th>Total Collection</th>
                           <th>Total AR</th>
                           <th>Total Expenses</th>
                           <th>Total Remitted</th>
                           <th>Total Variance</th>
                        </tr>
                     </thead>
                     <tbody>
                        {
                           list.length > 0 ? list.map((item) => {
                              const salesDate = Moment(item.report_date).format('MMMM DD, YYYY');
                              const itemSales = global.parseToNumber(item.sales);
                              const itemCollection = global.parseToNumber(item.collection);
                              const itemAr = global.parseToNumber(item.ar);
                              const itemExpenses = global.parseToNumber(item.expenses);
                              const itemRemitted = global.parseToNumber(item.remitted);
                              const itemVariance = global.parseToNumber(item.variance);

                              return (
                                 <tr key={item.daily_report_id} data-href={item.daily_report_id} onClick={this.goTo.bind(this)} className="text-center">
                                    <td className="text-left">{item.location_name}</td>
                                    <td className="text-left">{salesDate}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(itemSales)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(itemCollection)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(itemAr)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(itemExpenses)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(itemRemitted)}</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(itemVariance)}</td>
                                 </tr>
                              );
                           }) : (
                              <tr className="text-center">
                                 <td colSpan="8">No data available..</td>
                              </tr>
                           )
                        }
                     </tbody>
                  </Table>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(SalesReport);
